<template>
  <div id="category-member-type-tab">
    <div class="at-member-tab-left-container">
      <div
        v-for="(cat, idx) in leftCategory"
        :key="idx"
        :class="[
          leftActiveTab === cat.value ? 'active' : '',
          loading ? 'loading' : '',
          'at-member-tab',
        ]"
        @click="leftToggle(cat.value)"
      >
        <span
          v-if="!cat.hide"
          class="at-member-label"
        >{{ cat.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import customerMixin from '@shared/mixins/customerMixin';

export default {
  name: 'CategoryMemberTab',
  mixins: [customerMixin],
  props: {
    leftActiveTab: String,
    rightActiveTab: String,
    leftCategory: Array,
    rightCategory: Array,
    leftToggle: Function,
    rightToggle: Function,
  },
};
</script>

<style lang="scss">

#category-member-type-tab {
  display: flex;
  align-items: center;
  height: 52px;
  padding: 0 16px;

  .at-member-tab-left-container {
    display: flex;
    align-items: center;
  }

  .at-member-tab-right-container {
    display: flex;
    align-items: center;
  }

  .at-member-tab-checkbox {
    display: flex;
    align-items: center;
    padding: 0 16px;
    cursor: pointer;
    color: $BLACK;
    font-size: 1rem;
    font-weight: 500;
    height: 36px;
  }

  .at-member-tab {
    display: flex;
    align-items: center;
    padding: 0 16px;
    cursor: pointer;
    color: $BLACK;
    font-size: 1.125rem;
    font-weight: 500;
    height: 56px;

    .at-count {
      margin-left: 8px;
      background-color: $N100;
      color: $WHITE;
      font-size: 0.875rem;
      height: 20px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      padding: 3px 11px 3px 12px;
    }

    &:not(.loading) {
      &:hover {
        background-color: $NBLUE10;
      }

      &.active {
        color: $NBLUE100;
        background-color: $NBLUE10;

        .at-member-label {
          margin-bottom: -3px;
        }

        .at-count {
          margin-bottom: -3px;
        }
      }
    }
  }

  .at-member-tab {
    display: flex;
    align-items: center;
    padding: 0 16px;
    cursor: pointer;
    color: $BLACK;
    font-size: 1.125rem;
    font-weight: 500;
    height: 56px;

    &.red-info {
      color: $TOMATO100;

      .atr-member-count {
        background-color: $TOMATO100;
      }
    }

    &.yellow-info {
      color: $SUNSET100;

      .atr-member-count {
        background-color: $SUNSET100;
      }
    }

    &.green-info {
      color: $BASIL100;

      .atr-member-count {
        background-color: $BASIL100;
      }
    }

    .atr-member-count {
      margin-left: 8px;
      background-color: $N100;
      color: $WHITE;
      font-size: 0.875rem;
      height: 20px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      padding: 3px 11px 3px 12px;
    }

    &:not(.loading) {
      &:hover {
        background-color: $NBLUE10;
      }

      &.active {
        border-bottom: 3px $NBLUE100 solid;
        background-color: $NBLUE10;

        .atr-member-label {
          margin-bottom: -3px;
        }

        .atr-member-count {
          margin-bottom: -3px;
        }
      }
    }
  }
}
</style>
